import { generator, SiteActivityEvent } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const accountSettingsGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'accountSettings'
  return {
    // Update Email Modal: Close
    accountsettings_emailclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_emailclose_click'
      }
    },
    // Update eMSN Settings Modal: Close
    accountsettings_emsnclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_emsnclose_click'
      }
    },
    // Update Handbook Settings Modal: Close
    accountsettings_handbookclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_handbookclose_click'
      }
    },
    // Order Medicare Card Modal: Close
    accountsettings_ordercardclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_ordercardclose_click'
      }
    },
    // Update Password Modal: Close
    accountsettings_password_close: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_password_close'
      }
    },
    // Update Secret Question Modal: Close
    accountsettings_secretclose_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_secretclose_click'
      }
    },
    // Update Name/Address (SS) Drawer: Open
    accountsettings_ssupdatenameoraddress_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.AccountSettings,
        elementId: 'accountsettings_ssupdatenameoraddress_opendrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Open
    accountsettings_rrbupdatenameoraddress_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.AccountSettings,
        elementId: 'accountsettings_rrbupdatenameoraddress_opendrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Close
    accountsettings_rrbpdatenameoraddress_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.AccountSettings,
        elementId: 'accountsettings_rrbpdatenameoraddress_closedrawer'
      }
    },
    // Update Name/Address (SS) Drawer: Close
    accountsettings_ssupdatenameoraddress_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.AccountSettings,
        elementId: 'accountsettings_ssupdatenameoraddress_closedrawer'
      }
    },
    // Update Name/Address (RRB) Drawer: Link 1 Click
    accountsettings_drawerrrbupdatenameoraddress_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_drawerrrbupdatenameoraddress_click',
        coreClickData: {
          linkText: i18n.t('drawer.rrb.li1.linkText', { ns }),
          linkUrl: 'https://rrb.gov/Benefits/myRRB'
        }
      }
    },
    // Update Name/Address (RRB) Drawer: Link 3 Click
    accountsettings_drawerrrbofficefinder_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_drawerrrbofficefinder_click',
        coreClickData: {
          linkText: i18n.t('drawer.rrb.li3.linkText', { ns }),
          linkUrl: 'https://rrb.gov/Field-Office-Locator'
        }
      }
    },
    // Update Name/Address (SS) Drawer: Link 1 Click
    accountsettings_drawerssupdatenameoraddress_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_drawerssupdatenameoraddress_click',
        coreClickData: {
          linkText: i18n.t('drawer.ssa.li1.linkText', { ns }),
          linkUrl: 'https://www.ssa.gov/myaccount/'
        }
      }
    },
    // Update Name/Address (SS) Drawer: Link 3 Click
    accountsettings_drawerssofficefinder_click: {
      core: {
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_drawerssofficefinder_click',
        coreClickData: {
          linkText: i18n.t('drawer.ssa.li3.linkText', { ns }),
          linkUrl: 'https://www.ssa.gov/myaccount/'
        }
      }
    },
    // Update Username Modal: Close
    accountsettings_username_close: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_username_close'
      }
    },
    accountsettings_deleteaccount_click: (params: {
      linkText?: string
      linkUrl?: string
    }): SiteActivityEvent => ({
      core: {
        elementId: 'accountsettings_deleteaccount_click',
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    accountsettings_backtoaccountsettingsfromdeleteaccount_click: (params: {
      linkText?: string
      linkUrl?: string
    }): SiteActivityEvent => ({
      core: {
        elementId:
          'accountsettings_backtoaccountsettingsfromdeleteaccount_click',
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    accountsettings_changeyouremailpreferences_click: (params: {
      linkText?: string
      linkUrl?: string
    }): SiteActivityEvent => ({
      core: {
        elementId: 'accountsettings_changeyouremailpreferences_click',
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    accountsettings_deleteaccountconfirm_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.AccountSettings,
        elementId: 'accountsettings_deleteaccountconfirm_click',
        coreClickData: {
          linkText: i18n.t('content.submitText', { ns: 'deleteAccount' })
        }
      }
    },
    accountsettings_deleteaccountcancel_click: (params: {
      linkText?: string
      linkUrl?: string
    }): SiteActivityEvent => ({
      core: {
        elementId: 'accountsettings_deleteaccountcancel_click',
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    }),
    accountsettings_changeaccountemail2_click: (params: {
      linkText?: string
      linkUrl?: string
    }): SiteActivityEvent => ({
      core: {
        elementId: 'accountsettings_changeaccountemail2_click',
        property: 'MAX',
        activity: Activity.LinkClick,
        component: Component.AccountSettings,
        coreClickData: {
          linkText: params.linkText,
          linkUrl: params.linkUrl
        }
      }
    })
  } // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type AccountSettingsKeys = keyof ReturnType<
  typeof accountSettingsGenerator
>

export default accountSettingsGenerator
